// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-15GY6";
var _4 = "timeImage-2mVND";
var _5 = "text-1h5kV";
var _6 = "button-3o0rx";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "timeImage", _5 as "text", _6 as "button" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "timeImage": _4, "text": _5, "button": _6 }
